import { Component, SimpleChanges, OnInit, Input, OnChanges, ViewChildren } from '@angular/core';
import { PieChartComponent } from '../../../common-components/charts/pie-chart/pie-chart.component';
import { LineChartComponent } from '../../../common-components/charts/line-chart/line-chart.component';
import { IBasicChart } from 'app/rpa-bots/uipath/common/models/IBasicChart';
import { IDataCharts } from 'app/rpa-bots/uipath/common/models/IDataCharts';
import { ILineChart } from 'app/rpa-bots/uipath/common/models/ILineChart';

@Component({
  selector: 'biz-uipath-job-dashboard',
  templateUrl: './uipath-job-dashboard.component.html',
  styleUrls: ['./uipath-job-dashboard.component.scss']
})
export class UipathJobDashboardComponent implements OnInit, OnChanges {

  private listTimeOut: any[] = [];

  public dataChartJobStatusLastDay: IBasicChart[];
  public dataChartJobStatusLastWeek: IBasicChart[];
  public dataChartJobStatusLastMonth: IBasicChart[];
  public dataChartJobStatusLastYear: ILineChart;
  public isLoading: boolean = true;
  @Input() tabIndex: number;
  @Input() dataJobsChart: IDataCharts;

  @ViewChildren(PieChartComponent) pieChartList: PieChartComponent[];
  @ViewChildren(LineChartComponent) lineChart: LineChartComponent[];

  filterDateFrom: String;
  filterDateTo: String;

  emptyChart: IBasicChart[] = [{
    letter: 'Empty Data',
    frequency: 1
  }]

  constructor() {

  }

  public refresh() {
    if (this.pieChartList && this.lineChart) {
      this.listTimeOut.push(setTimeout(() => {
        this.pieChartList.forEach((chart: PieChartComponent) => {
          chart.refresh();
        });

        this.lineChart.forEach((chart: LineChartComponent) => {
          chart.refresh();
        });
      }));
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataJobsChart && changes.dataJobsChart.currentValue) {
      this.isLoading = false;
      this.dataChartJobStatusLastDay = this.dataJobsChart.LastDayData;
      this.dataChartJobStatusLastWeek = this.dataJobsChart.LastWeekData;
      this.dataChartJobStatusLastMonth = this.dataJobsChart.LastMonthData;
      this.dataChartJobStatusLastYear = this.dataJobsChart.LastYearData;
    } else {
      this.isLoading = false;
    }
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
  }

}
